import React from 'react';
import { t } from 'i18next';

import './index.less';

import { getDefaultIfUndefined } from '../../../utils/typeUtil';
import IbButton from '../IbButton';
import IbIcon from '../IbIcon';
import { CodeEditorStatus } from '../CodeEditor/types';
import { DEFAULT_EDITOR_STATUS } from '../CodeEditor/const';

import { CodeEditorSize } from './types';
import {
  DEFAULT_EDITOR_SIZE,
  EDITOR_CLASS_NAME,
  FULLSCREEN_CLASS_NAME,
  MAIN_CLASS_NAME,
  READONLY_CLASS_NAME,
  TOOLBAR_CLASS_NAME,
} from './const';

export interface ICodeEditorExpandableProps {
  className?: string;
  size?: CodeEditorSize;
  status?: CodeEditorStatus;
  readOnly?: boolean;
  isFullscreen?: boolean;
  toolbar?: boolean;
  onFullscreenToggle?: (value: boolean) => void;
}

const CodeEditorExpandable: React.FC<ICodeEditorExpandableProps> = ({
  className,
  size = DEFAULT_EDITOR_SIZE,
  status = DEFAULT_EDITOR_STATUS,
  readOnly,
  isFullscreen,
  toolbar = true,
  onFullscreenToggle,
  children,
}) => {
  size = getDefaultIfUndefined(size, DEFAULT_EDITOR_SIZE);
  status = getDefaultIfUndefined(status, DEFAULT_EDITOR_STATUS);
  toolbar = getDefaultIfUndefined(toolbar, true);

  const classes = [MAIN_CLASS_NAME, `${MAIN_CLASS_NAME}_${status}`];
  className && classes.push(className);
  readOnly && classes.push(READONLY_CLASS_NAME);

  isFullscreen && classes.push(FULLSCREEN_CLASS_NAME);

  const onFullscreenButtonClick = () => onFullscreenToggle?.(!isFullscreen);

  return (
    <div className={classes.join(' ')}>
      {toolbar && (
        <div className={TOOLBAR_CLASS_NAME}>
          <IbButton
            icon={<IbIcon iconName={isFullscreen ? 'offscreen-two' : 'fullscreen-two'} />}
            type="icon"
            onClick={onFullscreenButtonClick}
          >
            {isFullscreen && t('Minimize')}
          </IbButton>
        </div>
      )}
      <div className={`${EDITOR_CLASS_NAME} ${EDITOR_CLASS_NAME}_${size}`}>{children}</div>
    </div>
  );
};

export default CodeEditorExpandable;
